import { Link } from 'react-router-dom';
import logo from './img/O.png';
import { useI18n } from './i18n';
import { telHref, waHref, PHONE_DISPLAY } from './phone';
import LangSwitch from './langswitch';
import './App.css';

export default function Header() {
  const { t } = useI18n();
  return (
    <>
      <header className="os-header">
        <div className="os-header-in">
          <Link to="/" className="os-brand" aria-label={t('nav.home')}>
            <img src={logo} alt="" width="30" height="30" />
            <span className="os-wordmark">ORTOSOFT</span>
          </Link>
          <nav className="os-header-nav" aria-label={t('nav.contact')}>
            <a className="os-btn" href={telHref}>
              <span className="os-btn-tel">{t('nav.tel')} {PHONE_DISPLAY}</span>
              <span className="os-btn-tel-m">{t('nav.telShort')}</span>
            </a>
            <a className="os-btn" href="mailto:contact@ortosoft.fr">
              {t('nav.email')}
            </a>
            <a className="os-btn" href={waHref} target="_blank" rel="noopener noreferrer">
              WhatsApp
            </a>
          </nav>
        </div>
      </header>
      <LangSwitch />
    </>
  );
}
